import { toast } from 'react-toastify';
import i18n from '@/i18n';
import { CRITICAL_ERROR_TOAST_ID, LIMITED_CONTAINER_ID } from '@/config';

const showCriticalErrorToast = () =>
  toast.error(i18n.t('translation.something_went_wrong'), {
    toastId: CRITICAL_ERROR_TOAST_ID,
    containerId: LIMITED_CONTAINER_ID,
  });

export default showCriticalErrorToast;
